import { MatrixParameterValue } from "../interfaces/MatrixInputCell";

const customNumericValidator = (cell: MatrixParameterValue, callback: (valid: boolean) => void) => {
  const { parameterValue } = cell;
  if (parameterValue?.value === "") {
    callback(true);
  } else if (parameterValue?.value) {
    const valid = /^\s*(-|\+)?\d+(\.\d+)?\s*$/.test(parameterValue?.value);
    callback(valid);
  } else {
    callback(false);
  }
};

export default customNumericValidator;
